import script from "./EditAlias.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditAlias.vue?vue&type=script&lang=ts&setup=true"

import "./EditAlias.vue?vue&type=style&index=0&id=0d82d103&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d82d103"]])

export default __exports__